
import VeeValidate from 'vee-validate';
import vSelect from 'vue-select';
import Cookies from 'js-cookie';
import { DateTime as LuxonDateTime } from 'luxon';
import { Datetime } from 'vue-datetime/dist/vue-datetime';


const { Vue } = window;
Vue.use(VeeValidate);
window.workWithUs = new Vue({
  el: '#main',
  components: {
    vSelect,
    Datetime
  },
  data: {
    form: {
      retURL: `${window.location.href}#thankyou`,
      date: '',
      time: '',
      company: '',
      webUrl: ''
    },
    datepick: '',
    today: new Date().toISOString(),
    format: { year: 'numeric', month: 'short', day: 'numeric' },
    views: {
      thankyou: false
    },
    time: {
      placeholder: 'Select a time',
      options: [
        { label: 'Select a time', value: '' },
        { label: '8:00am', value: '8:00am' },
        { label: '8:30am', value: '8:30am' },
        { label: '9:00am', value: '9:00am' },
        { label: '9:30am', value: '9:30am' },
        { label: '10:00am', value: '10:00am' },
        { label: '10:30am', value: '10:30am' },
        { label: '11:00am', value: '11:00am' },
        { label: '11:30am', value: '11:30am' },
        { label: '12:00pm', value: '12:00pm' },
        { label: '12:30pm', value: '12:30pm' },
        { label: '1:00pm', value: '1:00pm' },
        { label: '1:30pm', value: '1:30pm' },
        { label: '2:00pm', value: '2:00pm' },
        { label: '2:30pm', value: '2:30pm' },
        { label: '3:00pm', value: '3:00pm' },
        { label: '3:30pm', value: '3:30pm' },
        { label: '4:00pm', value: '4:00pm' },
        { label: '4:30pm', value: '4:30pm' },
        { label: '5:00pm', value: '5:00pm' },
        { label: '5:30pm', value: '5:30pm' },
        { label: '6:00pm', value: '6:00pm' },
        { label: '6:30pm', value: '6:30pm' },
        { label: '7:00pm', value: '7:00pm' },
        { label: '7:30pm', value: '7:30pm' }
      ]
    }
  },
  methods: {
    initViews() {
      if (window.location.hash === '#thankyou') {
        this.showThankYouView();
      }
    },
    getCookies() {
      const oreo = Cookies.getJSON();
      this.form.company = oreo.tid || '';
    },
    showThankYouView() {
      this.views.thankyou = true;
    },
    clearDate() {
      this.form.date = '';
    },
    validateForm() {
      if (this.form.company === '') this.form.company = this.form.webUrl;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitForm();
        }
      });
    },
    submitForm() {
      Vue.nextTick(() => {
        document.getElementById('form').submit();
      });
    }
  },
  mounted() {
    this.initViews();
    this.getCookies();
  },
  computed: {
    setDateTime() {
      const date = this.form.date ? LuxonDateTime.fromISO(this.form.date).toLocaleString(this.format) : '';
      return `${date} ${this.form.time.value}`;
    }
  }
});
